import { render, staticRenderFns } from "./VProductLinks.vue?vue&type=template&id=02e78042&scoped=true"
import script from "./VProductLinks.vue?vue&type=script&lang=ts"
export * from "./VProductLinks.vue?vue&type=script&lang=ts"
import style0 from "./VProductLinks.vue?vue&type=style&index=0&id=02e78042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e78042",
  null
  
)

export default component.exports